import { USER_ID, AUTH_TOKEN } from './constants';

function timeDifference(current, previous) {
  const milliSecondsPerMinute = 60 * 1000;
  const milliSecondsPerHour = milliSecondsPerMinute * 60;
  const milliSecondsPerDay = milliSecondsPerHour * 24;
  const milliSecondsPerMonth = milliSecondsPerDay * 30;
  const milliSecondsPerYear = milliSecondsPerDay * 365;

  const elapsed = current - previous;

  if (elapsed < milliSecondsPerMinute / 3) {
    return 'just now';
  }

  if (elapsed < milliSecondsPerMinute) {
    return 'less than 1 min ago';
  } else if (elapsed < milliSecondsPerHour) {
    return Math.round(elapsed / milliSecondsPerMinute) + ' min ago';
  } else if (elapsed < milliSecondsPerDay) {
    return Math.round(elapsed / milliSecondsPerHour) + ' h ago';
  } else if (elapsed < milliSecondsPerMonth) {
    return Math.round(elapsed / milliSecondsPerDay) + ' days ago';
  } else if (elapsed < milliSecondsPerYear) {
    return Math.round(elapsed / milliSecondsPerMonth) + ' mo ago';
  } else {
    return Math.round(elapsed / milliSecondsPerYear) + ' years ago';
  }
}

export function timeDifferenceForDate(date) {
  const now = new Date().getTime();
  const updated = new Date(date).getTime();
  return timeDifference(now, updated);
}

// Returns delta from supplied datestring in seconds
export function fromNow(dateString) {
  const now = new Date();
  const date = new Date(dateString);
  const dTime = Math.abs(now - date);
  const dSeconds = Math.ceil(dTime / 1000);
  return dSeconds;
}

export function stripUrl(url) {
  const regex = /([^/,\s]+\.[^/,\s]+?)(?=\/|,|\s|$|\?|#)/g;
  const match = url.match(regex);
  return match && match.length ? match[0] : url;
}

export function validateEmail(email) {
  if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/.test(email)) {
    return true;
  }
  return false;
}

export function getUrlParams() {
  const vars = {};
  window.location.href.replace(
    /[?&]+([^=&]+)=([^&]*)/gi,
    function (m, key, value) {
      vars[key] = value;
    },
  );
  return vars;
}

export function addUrlRefParam(inputUrl) {
  const url = new URL(inputUrl);
  const searchParams = url.searchParams;

  searchParams.set('ref', 'mlnews');
  url.search = searchParams.toString();

  return url.toString();
}

export function countRepliesRecursively(replies, count) {
  return replies.reduce((acc, reply) => {
    return reply.replies
      ? countRepliesRecursively(reply.replies, acc + 1)
      : acc + 1;
  }, count);
}

export function commentFormatter(text) {
  const rows = text.split('\n');
  const formattedRows = rows.map((row) => {
    // Check for code block
    if (row.slice(0, 2) === '  ') {
      return `<div class="code-block">${row.replace(/ /g, '\u00a0')}</div>`;
    }
    // Check for italic
    if ((row.match(/\*(.*?)\*/gm) || []).length) {
      return row.replace(/\*(.*?)\*/gm, '<i>$1</i>');
    }
    return row;
  });
  return formattedRows.join('\n');
}

export function flattenReplies(replies = []) {
  return [
    ...replies,
    ...replies
      .filter((reply) => reply.replies && reply.replies.length)
      .map((reply) => flattenReplies(reply.replies))
      .flat(),
  ];
}

export function handleUnauthorized(error, history) {
  if (
    error &&
    error.graphQLErrors.some((error) => error.includes('Not authenticated'))
  ) {
    localStorage.removeItem(AUTH_TOKEN);
    localStorage.removeItem(USER_ID);
    if (history.location.pathname !== '/login') {
      window.location.pathname = '/login';
    }
  }
}

export const repliesFragment = `
  replies {
    id
    created
    text
    votes { 
      id
      user {
        id
      }
    }
    user {
      id
      name
    }
    comment {
      id
      text
    }
    reply {
      id
      text
    }
    replies {
      id
      created
      text
      votes { 
        id 
        user {
          id
        }
      }
      user {
        id
        name
      }
      reply {
        id
        text
      }
      replies {
        id
        created
        text
        votes { 
          id 
          user {
            id
          }
        }
        user {
          id
          name
        }
        reply {
          id
          text
        }
        replies {
          id
          created
          text
          votes { 
            id 
            user {
              id
            }
          }
          user {
            id
            name
          }
          reply {
            id
            text
          }
          replies {
            id
            created
            text
            votes { 
              id 
              user {
                id
              }
            }
            user {
              id
              name
            }
            reply {
              id
              text
            }
            replies {
              id
              created
              text
              votes { 
                id 
                user {
                  id
                }
              }
              user {
                id
                name
              }
              reply {
                id
                text
              }
              replies {
                id
                created
                text
                votes { 
                  id 
                  user {
                    id
                  }
                }
                user {
                  id
                  name
                }
                reply {
                  id
                  text
                }
                replies {
                  id
                  created
                  text
                  votes { 
                    id 
                    user {
                      id
                    }
                  }
                  user {
                    id
                    name
                  }
                  reply {
                    id
                    text
                  }
                  replies {
                    id
                    created
                    text
                    votes { 
                      id 
                      user {
                        id
                      }
                    }
                    user {
                      id
                      name
                    }
                    reply {
                      id
                      text
                    }
                    replies {
                      id
                      created
                      text
                      votes { 
                        id 
                        user {
                          id
                        }
                      }
                      user {
                        id
                        name
                      }
                      reply {
                        id
                        text
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  
`;

export const repliesFragmentForCounting = `
  replies {
    id
    replies {
      id
      replies {
        id
        replies {
          id
          replies {
            id
            replies {
              id
              replies {
                id
                replies {
                  id
                  replies {
                    id
                    replies {
                      id
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  
`;



// WEBPACK FOOTER //
// ./src/utils.js